import http from "./base";

class MenuJobService{
    constructor(){}

    async getAllMenuJobs() {
        const url = `menuJobs/getAll/`;
      
        let response = "";
        await http
          .get(url, {
            headers: {
              Authorization: 'Bearer ' + sessionStorage.getItem('token')
            },
            cache: false
          })
          .then(responseData => {
            response = responseData.data.data;
          })
          .catch(error => {
            response = error.response;
            throw new Error(`HTTP error! status: ${response.status}`);
          });
      
        return response;
      }
      

    async saveNewMenuJob(body) {
        const url = `menuJobs/extractMenuItems`;

        const formData = new FormData();
        formData.append('image', body.image); // File object
        formData.append('userID', sessionStorage.getItem('user'));    // Text field
        var response = "";
        await http
            .post(url, formData,{
                headers: {
                    authorization: 'Bearer ' + sessionStorage.getItem('token'),
                    'Content-Type': 'multipart/form-data' // Important for file upload
                  },
            })
            .then(responseData => {
                response = responseData.data.data;
            })
            .catch(error => {
                response = error.response;
                throw new Error(`HTTP error! status: ${response.status}`);
            });

        return response;
    }


    async createMenu(body) {
        const url = `menuJobs/createMenu`;
        var response = "";
        await http
            .post(url, body,{
                headers: {
                    authorization: 'Bearer ' + sessionStorage.getItem('token')
                  },
            })
            .then(responseData => {
                response = responseData.data.data;
            })
            .catch(error => {
                response = error.response;
                throw new Error(`HTTP error! status: ${response.status}`);
            });

        return response;
    }



}

let service = new MenuJobService();
export default service;



